import { LocationNumbersService } from '../../../services'

const createTollFreeVerification = async function (
  { commit, state, getters },
  config
) {
  const { companyId, tollFreePhoneNumberSID, locationId, payload } = config

  try {
    const {data} = await LocationNumbersService.createTollFreeVerificationRequest(
      companyId,
      locationId,
      payload
    ) as any

    const requestData = data?.tollFreeRequest

    commit('setTollFreeDataAt', {
      sid: tollFreePhoneNumberSID ?? requestData?.tollfreePhoneNumberSid ?? requestData?.tollfree_phone_number_sid,
      tollFreeRequest: requestData,
    })

    commit(
      'setPhoneNumbers',
      getters.getCorrectedPhoneNumbers(state.phoneNumbers)
      )

    return Promise.resolve(requestData)
  } catch (error) {
    commit('setTollFreeDataAt', {
      sid: tollFreePhoneNumberSID,
      tollFreeRequest: null,
    })
    return Promise.reject(error)
  }
}

export default createTollFreeVerification
